/**
 * ComprasConfirmDialogs - AlertDialogs de confirmação do módulo Compras
 * (extraído de Compras.jsx): confirmar edição de cotação com respostas,
 * excluir cotação, excluir pedido e descartar alterações de resposta.
 */
import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';
import { Label } from '../ui/label';
import { Input } from '../ui/input';

const ComprasConfirmDialogs = ({
  // Confirmar edição de cotação com respostas
  confirmEditCotacao,
  onCloseEditConfirm,
  onConfirmEdit,
  // Excluir cotação
  deleteCotacaoId,
  onCloseDeleteCotacao,
  onConfirmDeleteCotacao,
  // Excluir pedido
  deletePedidoId,
  onCloseDeletePedido,
  onConfirmDeletePedido,
  // Motivo compartilhado (exclusões)
  deleteMotivo,
  onDeleteMotivoChange,
  // Descartar alterações de resposta
  confirmCloseResposta,
  onConfirmCloseRespostaChange,
  respostaPendingCount,
  onDiscardResposta,
}) => {
  return (
    <>
      {/* Alert Dialog Confirmar Edição de Cotação com Respostas */}
      <AlertDialog open={!!confirmEditCotacao} onOpenChange={(o) => { if (!o) onCloseEditConfirm(); }}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirma edição?</AlertDialogTitle>
            <AlertDialogDescription>
              Esta cotação <strong>{confirmEditCotacao?.numero}</strong> já possui respostas registradas de fornecedores.
              <br /><br />
              Ao prosseguir, você poderá adicionar/remover fornecedores e itens, alterar quantidades e valores. As alterações ficarão registradas nos logs de auditoria.
              <br /><br />
              <span className="text-red-600 font-medium">Esta ação não poderá ser desfeita.</span> Deseja continuar?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="cancel-edit-cotacao-confirm">Cancelar</AlertDialogCancel>
            <AlertDialogAction
              data-testid="confirm-edit-cotacao"
              onClick={() => onConfirmEdit(confirmEditCotacao)}
              className="bg-amber-600 hover:bg-amber-700"
            >
              Confirmar e editar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Alert Dialog Excluir Cotação */}
      <AlertDialog open={!!deleteCotacaoId} onOpenChange={() => onCloseDeleteCotacao()}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Excluir cotação?</AlertDialogTitle>
            <AlertDialogDescription>
              A cotação será marcada como excluída e não aparecerá mais nas listagens. Esta ação ficará registrada nos logs de auditoria.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <div className="py-2">
            <Label className="text-sm">Motivo da exclusão</Label>
            <Input
              value={deleteMotivo}
              onChange={(e) => onDeleteMotivoChange(e.target.value)}
              placeholder="Informe o motivo..."
              className="mt-1"
              data-testid="input-motivo-exclusao-cotacao"
            />
          </div>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={onConfirmDeleteCotacao} className="bg-red-600 hover:bg-red-700">
              Confirmar Exclusão
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Alert Dialog Excluir Pedido */}
      <AlertDialog open={!!deletePedidoId} onOpenChange={() => onCloseDeletePedido()}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Excluir pedido de compra?</AlertDialogTitle>
            <AlertDialogDescription>
              O pedido será marcado como excluído. Se o pedido já foi recebido, o estoque será revertido automaticamente e as parcelas no Conta Azul serão marcadas para cancelamento. Esta ação ficará registrada nos logs.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <div className="py-2">
            <Label className="text-sm">Motivo da exclusão</Label>
            <Input
              value={deleteMotivo}
              onChange={(e) => onDeleteMotivoChange(e.target.value)}
              placeholder="Informe o motivo..."
              className="mt-1"
              data-testid="input-motivo-exclusao-pedido"
            />
          </div>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={onConfirmDeletePedido} className="bg-red-600 hover:bg-red-700">
              Confirmar Exclusão
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Confirmação de fechamento com alterações pendentes */}
      <AlertDialog open={confirmCloseResposta} onOpenChange={onConfirmCloseRespostaChange}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Descartar alterações?</AlertDialogTitle>
            <AlertDialogDescription>
              Você tem alterações de <strong>{respostaPendingCount} fornecedor(es)</strong> que ainda não foram salvas.
              <br /><br />
              Se fechar agora, esses dados serão <strong className="text-red-600">perdidos</strong>. Deseja continuar?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="cancel-close-resposta">Continuar editando</AlertDialogCancel>
            <AlertDialogAction
              data-testid="confirm-close-resposta"
              onClick={onDiscardResposta}
              className="bg-red-600 hover:bg-red-700"
            >
              Descartar e fechar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default ComprasConfirmDialogs;
